var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveoutlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 23.4V67.3357C22 67.441 22.0415 67.542 22.1155 67.6169L64.3155 110.308C64.5668 110.562 65 110.384 65 110.026V23.4C65 23.1791 64.8209 23 64.6 23H22.4C22.1791 23 22 23.1791 22 23.4ZM37.5 46C42.1944 46 46 42.1944 46 37.5C46 32.8056 42.1944 29 37.5 29C32.8056 29 29 32.8056 29 37.5C29 42.1944 32.8056 46 37.5 46Z",
    fill: "#D86262"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69 110.026V25.1094C69 24.7523 69.4325 24.5742 69.684 24.8278L111.721 67.2188C111.876 67.3746 111.876 67.6257 111.722 67.7817L69.6845 110.308C69.4332 110.562 69 110.384 69 110.026Z",
    fill: "#2563EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveoutlogo);
export default __webpack_public_path__ + "static/media/moveoutlogo.244fdc9ce6bcdf9a5d0b891e82e6337e.svg";
export { ForwardRef as ReactComponent };